import DropdownTrigger from './DropdownTrigger';
import './DropdownTrigger.scss';

export default DropdownTrigger;
